// src/components/Footer.jsx
import styles from '../styles/Footer.module.css';
import T from './T';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.brand}>
            <span className={styles.logo}>Autochek</span>
            <span className={styles.separator}>•</span>
            <span className={styles.tagline}><T>Tech Support</T></span>
          </div>
          <p className={styles.copyright}>
            &copy; {currentYear} Autochek Africa. <T>All rights reserved</T>.
          </p>
        </div>
      </div>
    </footer>
  );
}
